import { server } from '../server';
import { AccessTokenStore } from './accessTokenStore';
export const refreshAccessToken = async (walletAddress) => {
    const response = await server.post({
        endpoint: `user/${walletAddress.toLowerCase()}/refresh`,
    }, {
        credentials: 'include',
    });
    if (!response.ok) {
        console.error('error refreshing access token', response.statusText);
        return { success: false };
    }
    const data = await response.json();
    try {
        AccessTokenStore.getInstance().accessToken = data.access_token;
    }
    catch (error) {
        console.error(error);
        return { success: false };
    }
    return { success: true, token: data.access_token };
};
